'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var index = require('../SelectItem/index.js');
var style = require('../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const SelectListStyled = styled__default["default"].div.withConfig({
  componentId: "sc-1fmou4-0"
})(["width:100%;display:flex;flex-direction:column;gap:8px;"]);
const SelectListOptionStyled = styled__default["default"](index["default"]).withConfig({
  componentId: "sc-1fmou4-1"
})(["padding:0.875rem 1rem;", " flex-grow:1;text-align:start;font-weight:inherit;margin:0;"], _ref => {
  let {
    theme
  } = _ref;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
});

exports.SelectListOptionStyled = SelectListOptionStyled;
exports.SelectListStyled = SelectListStyled;
